import {Fct_Inputs} from '../../query/graphql';
import {FCT_SCENARIOS} from './data/fctScenarios';

export type FctScenario = {
  id: string;
  inputSets: {
    endpoint: string;
    inputs: Fct_Inputs;
  }[];
};

export const CURRENT_SCENARIO_IDS: (keyof typeof FCT_SCENARIOS)[] = [
  'arable_3yr_baseline',
  'arable_5yr_baseline',
  'arable_3yr_hemp',
  'arable_5yr_hemp',
  'livestock_no_input_cattle',
  'livestock_low_input_cattle',
  'livestock_high_input_cattle',
  'livestock_high_input_silage_cattle',
  'livestock_no_input_sheep',
  'livestock_low_input_sheep',
];

export const TARGET_SCENARIO_IDS: (keyof typeof FCT_SCENARIOS)[] = [
  'biomass_miscanthus_arable',
  'biomass_switchgrass_arable',
  'biomass_reedcanary_arable',
  'biomass_SRC_willow_arable',
  'biomass_SRC_poplar_arable',
  'biomass_miscanthus_grassland',
  'biomass_switchgrass_grassland',
  'biomass_reedcanary_grassland',
  'biomass_SRC_willow_grassland',
  'biomass_SRC_poplar_grassland',
];

export type CurrentScenarioId = typeof CURRENT_SCENARIO_IDS[number];
export type TargetScenarioId = typeof TARGET_SCENARIO_IDS[number];

export const SCENARIO_NAMES: Record<CurrentScenarioId | TargetScenarioId, string> = {
  arable_3yr_baseline: 'Three year arable rotation',
  arable_3yr_hemp: 'Three year arable with hemp',
  arable_5yr_baseline: 'Five year arable rotation',
  arable_5yr_hemp: 'Five year arable with hemp',
  biomass_SRC_poplar_arable: 'SRC poplar onto arable land',
  biomass_SRC_poplar_grassland: 'SRC poplar onto grassland',
  biomass_SRC_willow_arable: 'SRC willow onto arable land',
  biomass_SRC_willow_grassland: 'SRC willow onto grassland',
  biomass_miscanthus_arable: 'Miscanthus onto arable land',
  biomass_miscanthus_grassland: 'Miscanthus onto grassland',
  biomass_reedcanary_arable: 'Reed canary onto arable land',
  biomass_reedcanary_grassland: 'Reed canary grass onto grassland',
  biomass_switchgrass_arable: 'Switchgrass onto arable land',
  biomass_switchgrass_grassland: 'Switchgrass onto grassland',
  livestock_high_input_cattle: 'High input grazing cattle',
  livestock_high_input_silage_cattle: 'High input grazing cattle and silage',
  livestock_low_input_cattle: 'Low input grazing cattle',
  livestock_low_input_sheep: 'Low input grazing sheep',
  livestock_no_input_cattle: 'No input grazing cattle',
  livestock_no_input_sheep: 'No input grazing sheep',
};
